<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="SRODSTVO.NAZIV.SINGULAR"></span></label> -->
          <div class="col-md-10">
              <yt-input
                [Type]="'text'"
                [Label]="'SRODSTVO.NAZIV.SINGULAR'"
                name="txtNaziv"
                formControlName="Naziv"
                #autofocus
                autocomplete="off"
                #Naziv
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                   <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
                      <span translate="{{validation.message}}"></span>
                   </span>
                  </span>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
